import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itax-market',
  templateUrl: './itax-market.component.html',
  styleUrls: ['./itax-market.component.scss']
})
export class ItaxMarketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
